import { AxiosRequestConfig } from "axios";

export const patchSubscriptionConfig = (
  authorization: string | undefined,
  planId: string
): AxiosRequestConfig => ({
  method: "patch",
  url: `/me/subscription/${planId}/assign`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    Authorization: authorization && `Bearer ${authorization}`,
  },
});
